<div *ngIf="isVisible" 
     class="notification-container" 
     [ngClass]="[position, type]"
     (mouseenter)="pauseTimer()"
     (mouseleave)="resumeTimer()">
  <div class="notification-content">
    <i class="bi" [ngClass]="iconClass"></i>
    <span class="message">{{ message }}</span>
    <button class="close-button" (click)="close()">
      <i class="bi bi-x"></i>
    </button>
  </div>
</div>